import classNames from "classnames";
import { FC, memo, TextareaHTMLAttributes, useRef } from "react";

import { VALIDATION_CLASS } from "utils/constants";

type PropTypes = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: string;
  hint?: string;
  variant?: "primary" | "secondary";
  isRequired?: boolean;
  isDisabled?: boolean;
};

const Textarea: FC<PropTypes> = ({
  value,
  id,
  label,
  error,
  hint,
  className,
  variant = "primary",
  isDisabled,
  isRequired,
  ...props
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div
      onClick={() => textareaRef.current?.focus()}
      className={classNames("textarea", className, `textarea--${variant}`)}
    >
      <div
        className={classNames("textarea__field", {
          "textarea__field--filled": !!value,
          "textarea__field--error": !!error,
          [VALIDATION_CLASS]: !!error,
        })}
      >
        <textarea
          ref={textareaRef}
          {...props}
          id={id}
          value={value ?? ""}
          className="textarea__input"
          disabled={isDisabled}
        />

        {!!label && (
          <label
            htmlFor={id}
            className={classNames("textarea__label", {
              "textarea__label--required": isRequired,
            })}
          >
            {label}
          </label>
        )}
      </div>

      {!!error && <div className="textarea__error">{error}</div>}
      {!!hint && !error && <div className="textarea__hint">{hint}</div>}
    </div>
  );
};

export default memo(Textarea);
